<div class="po-xl-6 po-lg-6 po-md-12 po-sm-12 hourly-sales" id="hourly-sales">
  <po-widget>
    <div class="po-row">
      <div class="po-xl-8 po-lg-6 po-md-7 po-sm-7 po-pt-0 po-pl-0">
        <span class="po-font-text-bold title">Registro de vendas</span>
        <span class="po-ml-1 po-icon po-icon-exclamation" [p-tooltip]="topTooltip"></span>
        <span class="po-ml-1 po-icon po-icon-xml pointer-cursor" *ngIf="!loading && !errorApi" (click)="downloadExcel()"></span>
      </div>
      <div class="icon-loading" *ngIf="loading && !errorApi">
        <app-loading-icon></app-loading-icon>
      </div>
      <div class="po-xl-4 po-lg-6 po-md-5 po-sm-5 po-pt-0" *ngIf="!loading && !errorApi">
        <po-switch
          class="po-pt-0"
          name="serviceFee"
          [(ngModel)]="compraStatus"
          p-label-on="Comprou recente"
          p-label-off="Não comprou recente"
          [p-label-position]="labelPosition"
          (p-change)="changeCompraStatus()"
        >
        </po-switch>
      </div>
    </div>
    <div *ngIf="!loading && errorApi">
      <app-error [message]="message"></app-error>
    </div>
    <div class="po-table-main-container" *ngIf="!loading && !errorApi">
      <div class="po-table-wrapper" style="opacity: 1">
        <div style="height: 280px; min-width: 500px;">
          <table class="po-table">
            <thead>
              <tr class="po-table-header">
                <th class="po-table-header-ellipsis" (click)="ordenarTabela('cliente')">
                  <div class="po-table-header-flex">
                    <span class="po-table-header-ellipsis"> Cliente </span>
                    <span id="icon-cliente-sales-record" class="po-icon po-icon-arrow-down"></span>
                  </div>
                </th>
                <th class="po-table-header-ellipsis" (click)="ordenarTabela('data')">
                  <div class="po-table-header-flex">
                    <span class="po-table-header-ellipsis"> Última compra </span>
                    <span id="icon-data-sales-record" class="po-icon po-icon-arrow-down"></span>
                  </div>
                </th>
                <th class="po-table-header-ellipsis">
                  <div class="po-table-header-flex">
                    <span class="po-table-header-ellipsis"> Contato </span>
                  </div>
                </th>
                <th class="po-table-header-ellipsis">
                  <div class="po-table-header-flex">
                    <span class="po-table-header-ellipsis"> Ação </span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody class="po-table-group-row" *ngFor="let item of tableItens">
              <tr class="po-table-row">
                <td class="po-table-column" ng-reflect-ng-class="">
                  <div class="po-table-column-cell notranslate">
                    <span>{{item.cliente}}</span>
                  </div>
                </td>
                <td class="po-table-column" ng-reflect-ng-class="">
                  <div class="po-table-column-cell notranslate">
                    <span>{{item.ultimaCompra}}</span>
                  </div>
                </td>
                <td class="po-table-column value-column" ng-reflect-ng-class="">
                  <div class="po-table-column-cell notranslate">
                    <span>{{item.contato}}</span>
                  </div>
                </td>
                <td class="po-table-column value-column" ng-reflect-ng-class="">
                  <div class="po-table-column-cell notranslate" style="font-size: 20px; display: flex;">
                    <span id="waIcon" class="po-icon po-icon-social-whatsapp po-mt-1 po-mb-1 pointer-cursor" p-tooltip="Enviar mensagem pelo Whasapp" (click)="sendWa(item.contato)"></span>
                    <span id="copyIcon" class="po-icon po-icon-copy po-m-1 pointer-cursor" p-tooltip="Copiar contato" (click)="copyContact(item.contato)"></span>
                    <span id="chartIcon" class="po-icon po-icon-chart-columns po-m-1 po-ml-0 pointer-cursor" p-tooltip="Estatísticas do cliente" (click)="openChart(item)"></span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        
      </div>
      <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12 po-text-center po-pt-2 more-details po-clickable"
          (click)="goToSalesRecordDetails()">
          <span>+ Detalhes</span>
        </div>
    </div>
  </po-widget>
  <app-modal-person-statistics #modalStats [personSelect]="personSelect"
  [personStatisticsInfo]="personStatisticsInfo" [limitPersonInfo]="limitPersonInfo" 
  [openInvoiceValue]="openInvoiceValue" [branchCodes]="branchCodes"></app-modal-person-statistics>
</div>